var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('b-icon',{staticClass:"h1",attrs:{"icon":"shield-lock"}}),_c('h4',[_vm._v("شما به این بخش دسترسی ندارید.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }